import { ReactComponent as StatusWarning } from 'assets/icons/StatusWarning.svg';

interface SecuritySettingsWarningBoxProps {
  children: string;
}

const SecuritySettingsWarningBox = ({ children }: SecuritySettingsWarningBoxProps): JSX.Element => (
  <div className="flex w-full items-start gap-2 rounded-2xl bg-gray-10 p-4 text-gray-70">
    <StatusWarning className="h-5 w-5 shrink-0 stroke-warning-50 stroke-2" aria-hidden="true" />
    <span className="text-size-sm font-light leading-5">{children}</span>
  </div>
);

export default SecuritySettingsWarningBox;
